import { combineI18nMessages } from "@duosoftbg/nacid-components";
import { defaultMessagesEN } from "@duosoftbg/nacid-frontoffice-components";

const messagesEn = combineI18nMessages(defaultMessagesEN, {
  translation: {
    "t.ePortal": "Electronic portal",
    "t.services": "All services",
    "t.serviceSection.recognition": "Academic recognition",
    "t.serviceSection.professionalQualifications": "Professional qualifications",
    "t.serviceSection.makeEntries": "Making entries",
    "t.serviceSection.certificatesIssuing": "Issuing certificates",
    "t.serviceSection.generic": "Generic services",
    "t.serviceSection.officialNotes": "Official notes",
    "t.serviceSection.inquiries": "Inquiries for citations and impact factor",
    "t.serviceSection.documentServices": "Library document services",
    "t.serviceSection.analyticalProducts": "Bibliographic references",
    "t.serviceSection.apostille": "APOSTILLE",
    "t.new.application": "New application",
    "t.edit.application": "Edit application",
    "t.view.application": "View application",
    "t.secondary.school.details": "Secondary school data",
    "t.school.diploma": "Diploma data",
    "t.studied.subjects": "Subjects studied in the diploma",
    "t.recognitionPurposes": "Recognition purpose",
    "l.schoolSettlement": "Settlement",
    "l.schoolCountry": "Country where education took place",
    "l.schoolGradingScaleCountry": "Country by grading system",
    "l.isForeignGradingScale": "The grading system is from another country. Please select:",
    "l.schoolName": "School name",
    "l.number": "Number",
    "l.diploma.year": "Year of issue",
    "l.gradingScale": "Grading scale",

    "l.subjectName": "Subject name in the language of the diploma",
    "l.translatedSubjectName": "Subject name - translated",
    "l.diplomaGrade": "Grade as Stated in the Diploma",
    "l.profession.bg.title": " Title of the profession in Bulgarian",
    "l.profession.native.title": "Title of the profession in the language of the diploma",

    "t.prev.certificate": "Previous application for completed secondary education abroad",
    "t.page.signed.document.details": "Information about the submission process",
    "t.page.higherEduRecognition.short": "Recognition of acquired HE",
    "t.page.higherEduRecognition": "Recognition of acquired higher educa  tion in foreign universities",
    "t.page.higherEduRecognition.new":
      "New application for recognition of acquired higher education in foreign universities",
    "t.page.higherEduRecognition.edit":
      "Edit application for recognition of acquired higher education in foreign universities",
    "t.page.higherEduRecognition.view":
      "View application for recognition of acquired higher education in foreign universities",
    "t.page.secondaryEduRecognition":
      "Application for a Certificate of Recognition of Secondary Education Obtained in a Foreign Country",
    "t.page.secondaryEduRecognition.short": "Recognition of secondary education",
    "t.page.secondaryEduRecognition.breadCrumb": "Issuance of a Certificate",
    "t.page.secondaryEduRecognition.new":
      "Issuance of a Certificate of Recognition of Secondary Education Acquired in a School in a Foreign Country, for the Purpose of Continuing Education in Higher Education Institutions, Applying for a Driving License and Access to the Labor Market",
    "t.page.secondaryEduRecognition.edit":
      "Edit a Certificate of Recognition of secondary education acquired in a school in a foreign country, for the purpose of continuing education in higher education institutions, applying for a driving license and for access to the labor market",
    "t.page.secondaryEduVerificationLetter":
      "Issuance of a verification letter for the recognition of secondary education completed abroad for the purpose of acquiring a driving license and/or access to the labor market",
    "t.page.secondaryEduVerificationLetter.short": "Recognition of secondary education",
    "t.page.secondaryEduVerificationLetter.new.breadCrumb": "Issuance of a Verification Letter",
    "t.page.secondaryEduVerificationLetter.new":
      "Issuance of a Verification Letter for Recognition of Secondary Education Acquired in a School in a Foreign Country, for the Purpose of Applying for a Driving License and Access to the Labor Market",
    "t.page.secondaryEduVerificationLetter.edit":
      "Edit a Verification Letter for Recognition of Secondary Education Acquired in a School in a Foreign Country, for the Purpose of Applying for a Driving License and Access to the Labor Market",
    "t.page.secondaryEduOfficialNote":
      "Issuance of an official note for the recognition of grades in school subjects studied in secondary education but not reflected in the secondary education diploma",
    "t.page.secondaryEduOfficialNote.short": "Recognition of secondary education",
    "t.page.secondaryEduOfficialNote.new.breadCrumb": "Issuance of an Official Note",
    "t.page.secondaryEduOfficialNote.new":
      "Issuance of an Official Note for the Equivalency of Grades in Subjects Studied in School Education, but Not Reflected in the Secondary Education Document Acquired in a School in a Foreign Country",
    "t.page.secondaryEduOfficialNote.edit":
      "Edit an Official Note on the Equivalence of Grades in Subjects Studied in School Education, but Not Reflected in the Secondary Education Document Acquired in a School in a Foreign Country",
    "t.page.rudiAdditionalDoc.view": "View added additional documents to the academic recognition module",
    "t.page.rudiAdditionalDoc": "Additional documents to the academic recognition module",
    "t.page.rudiAdditionalDoc.short": "Additional documents",
    "t.page.rudiAdditionalDoc.new.breadCrumb": "Add additional documents",
    "t.page.rudiAdditionalDoc.new": "Add additional documents to the academic recognition module",
    "t.page.rudiAdditionalDoc.edit": "Edit additional documents in the academic recognition module",
    "t.page.regprofAdditionalDoc.view": "View added additional documents for the Professional Qualifications module",
    "t.page.regprofAdditionalDoc": "Additional documents for the Professional Qualifications module",
    "t.page.regprofAdditionalDoc.short": "Additional documents for the Professional Qualifications module",
    "t.page.regprofAdditionalDoc.new.breadCrumb": "Add additional documents",
    "t.page.regprofAdditionalDoc.new": "Add additional documents for the Professional Qualifications module",
    "t.page.regprofAdditionalDoc.edit": "Edit additional documents for the Professional Qualifications module",

    "t.page.seAdditionalDoc.view": "View added additional documents for the Secondary Education module",
    "t.page.seAdditionalDoc": "Additional documents for the Secondary Education module",
    "t.page.seAdditionalDoc.short": "Additional documents for the Secondary Education module",
    "t.page.seAdditionalDoc.new.breadCrumb": "Add additional documents",
    "t.page.seAdditionalDoc.new": "Add additional documents for the Secondary Education module",
    "t.page.seAdditionalDoc.edit": "Edit additional documents for the Secondary Education module",

    "t.page.libservAdditionalDoc.view":
      "View added additional documents for the Library and Information Services module",
    "t.page.libservAdditionalDoc": "Additional documents for the Library and Information Services module",
    "t.page.libservAdditionalDoc.short": "Additional documents for the Library and Information Services module",
    "t.page.libservAdditionalDoc.new.breadCrumb": "Add additional documents",
    "t.page.libservAdditionalDoc.new": "Add additional documents for the Library and Information Services module",
    "t.page.libservAdditionalDoc.edit": "Edit additional documents for the Library and Information Services module",

    "t.page.doctorateDegrees.short": "Doctorate degrees recognition",
    "t.page.doctorateDegrees.doctor":
      'Recognition of educational and scientific degree "Doctor", acquired in a foreign higher school/scientific organization',
    "t.page.doctorateDegrees.doctor.new": "New application for doctorate degree recognition",
    "t.page.doctorateDegrees.doctorOfScience":
      'Recognition of scientific degree "Doctor of science", acquired in a foreign higher school/scientific organization',
    "t.page.doctorateDegrees.doctorOfScience.new": "New application for doctorate degree recognition",
    "t.page.doctorateDegrees.edit": "Edit application for doctorate degree recognition",
    "t.page.doctorateDegrees.view": "View application for doctorate degree recognition",
    "t.page.regprof.short": "Issuing a certificate for PQ",
    "t.page.regprof":
      "Issuing a certificate for professional qualification for non regulated in Bulgaria profession for third countries",
    "t.page.regprof.new":
      "New application for issuing a certificate for professional qualification for non regulated in Bulgaria profession for third countries",
    "t.page.regprof.edit":
      "Edit application for issuing a certificate for professional qualification for non regulated in Bulgaria profession for third countries",
    "t.page.regprof.view":
      "View application for issuing a certificate for professional qualification for non regulated in Bulgaria profession for third countries",
    "t.page.uniChecks.short": "Status, authenticity, recommendation",
    "t.page.uniChecks.status": "Check of the academic status of foreign university",
    "t.page.uniChecks.authenticity":
      "Check of the document authenticity for higher education from foreign universities",
    "t.page.uniChecks.authenticity.new":
      "Check of the document authenticity for higher education from foreign universities",
    "t.page.uniChecks.recommendation":
      "Issuing of recommendation for recognition of higher education in foreign universities",
    "t.page.uniChecks.recommendation.new":
      "Issuing of recommendation for recognition of higher education in foreign universities",
    "t.page.uniChecks.new": "New application for statute/authenticity/recommendation",
    "t.page.uniChecks.edit": "Edit an application for statute/authenticity/recommendation",
    "t.page.uniChecks.view": "View an application for statute/authenticity/recommendation",
    "t.page.docDelivery.libraries":
      "Delivery of documents in paper or in electronic form from libraries in the country and abroad",
    "t.page.docDelivery.libraries.new":
      "New application for delivery of documents in paper or in electronic form from libraries in the country and abroad",
    "t.page.docDelivery.nacid": "Delivery of copies of documents from NACID",
    "t.page.docDelivery.nacid.new": "New application for delivery of copies of documents from NACID",
    "t.page.docDelivery.short": "Document services",
    "t.page.docDelivery.edit": "Edit application for document delivery",
    "t.page.docDelivery.view": "View application for document delivery",
    "t.page.biblioReference.foreign":
      "Preparation of a bibliographic reference by accessing foreign databases and other Internet resources",
    "t.page.biblioReference.foreign.new":
      "New application for preparation of a bibliographic reference by accessing foreign databases and other Internet resources",
    "t.page.biblioReference.nacid":
      "Preparation of a bibliographic reference by searching in the databases and e-catalogues of NACID",
    "t.page.biblioReference.nacid.new":
      "New application for preparation of a bibliographic reference by searching in the databases and e-catalogues of NACID",
    "t.page.biblioReference.short": "Preparation of a bibliographic reference",
    "t.page.biblioReference.edit": "Edit application for preparation of a bibliographic reference",
    "t.page.biblioReference.view": "View application for preparation of a bibliographic reference",
    "t.page.officialNotes.project": "Issuing of official note for completed scientific research projects",
    "t.page.officialNotes.project.new":
      "New application for issuing of official note for completed scientific research projects",
    "t.page.officialNotes.paper": "Issuing of official note for deposited scientific paper",
    "t.page.officialNotes.paper.new": "New application for issuing of official note for deposited scientific paper",
    "t.page.officialNotes.dissertation": "Issuing of certificate for defended dissertation",
    "t.page.officialNotes.dissertation.new": "New application for issuing of certificate for defended dissertation",
    "t.page.officialNotes.position": "Issuing of certificate for taken academic position",
    "t.page.officialNotes.position.new": "New application for issuing of certificate for taken academic position",
    "t.page.officialNotes.short": "Issuing of certificate for",
    "t.page.officialNotes.edit": "Edit an application for certificate",
    "t.page.officialNotes.view": "View an application for certificate",
    "t.page.inquiry.citings": "Preparation of an inquiry report for publication citations",
    "t.page.inquiry.citings.new": "New application for preparation of an inquiry report for  publication citations",
    "t.page.inquiry.factor": "Preparation of an inquiry report on the impact factor of scientific periodicals",
    "t.page.inquiry.factor.new":
      "New application for preparation of an inquiry report on the impact factor of scientific periodicals",
    "t.page.inquiry.short": "Preparation of an inquiry report for citations/impact factor",
    "t.page.inquiry.edit": "Edit an application for preparation of an inquiry report for citations/impact factor",
    "t.page.inquiry.view": "View an application for preparation of an inquiry report for citations/impact factor",
    "t.page.signal": "Filing a signal",
    "t.page.signal.new": "New application for filing a signal",
    "t.page.signal.short": "Filing a signal",
    "t.page.signal.edit": "Edit signal application",
    "t.page.signal.view": "View signal application",
    "t.page.suggestion": "Suggestion filing",
    "t.page.suggestion.new": "New application for suggestion filing",
    "t.page.suggestion.short": "Suggestion filing",
    "t.page.suggestion.edit": "Edit suggestion application",
    "t.page.suggestion.view": "View suggestion application",
    "t.page.publicAccess": "File application for public information access",
    "t.page.publicAccess.new": "New application for public information access",
    "t.page.publicAccess.short": "File application for public information access",
    "t.page.publicAccess.edit": "Edit application for public information access",
    "t.page.publicAccess.view": "View application for public information access",
    "t.page.my.applications": "My applications",
    "t.page.appCheckup": "Status report of requested service",
    "t.page.app.sign": "Sign application electronically",
    "t.page.my.correspondence": "My correspondence",
    "t.university.joint.universities": "Details for joint universities",
    "t.educationPlace.additional.places": "Additional education places",
    "t.studiedSubjects.additional.places": "Additional subjects",
    "t.attachment.dialog.title": "Add attached document",
    "t.evaluation.details": "Necessary details for filing the application",
    "t.service.tab.description": "Service description",
    "t.service.tab.applications": "My applications",
    "t.receiverAddress.details": "Receiver address",
    "t.docDelivery.bibliographicDetails.sub": "Bibliographic details for the documents you wish to receive",
    "t.inquiry.inquiryDetails": "Inquiry details",
    "t.fees.details": "Application fees",
    "t.confirm.file.unsigned": "Confirm you wish to file this application without e-signature",
    "t.correspondence.read.dialog.title": "View correspondence details",
    "t.application.correspondence.details": "Application correspondence details",
    "t.application.correspondence.basic.details": "Main details",
    "t.application.correspondence.doc.details": "Correspondence content",
    "t.application.certificate.details": "Issued certificate",
    "t.partial.data.dialog.title": "Incomplete data save",
    "t.additional.studied.subjects":
      "Subjects not listed in the diploma (for the purposes of issuing the official note only)",
    "m.additional.studied.subjects.info":
      "Enter the number and date (if any) of the document that records the grades for the subjects and the school years (classes) in which they were studied. If you have more than one such document, list all of them in the next field, and below it list all grades for the subjects and the school years (classes) in which they were studied, from all documents.",
    "t.additional.info": "Additional Information",
    "m.document.signed.single": "The document {{entryNumber}} was successfully submitted.",
    "m.document.signed.multiple": "The documents {{entryNumbers}} were successfully submitted.",

    "t.my.applications.action.title": "My Applications",
    "t.my.applications.action.description":
      "In the full implementation, this button will lead to a view of all applications for recognition of acquired secondary education submitted through this user profile.",
    "t.file.application.action.title": "Submission without e-signature",
    "t.file.application.action.description":
      "Your application has been successfully submitted to NACID. Since this is a demo version, it is not integrated with NACID's document management system, which would automatically generate an incoming number. For now, you can only download the receipt for the successfully submitted application in PDF format by clicking the 'View/Print' button.",
    "t.finalize.application.action.title": "Finalize and Sign",
    "t.finalize.application.action.description":
      "Your application has been successfully submitted to NACID. Since this is a demo version, it is not integrated with NACID's document management system, which would automatically generate an incoming number. For now, you can only download the receipt for the successfully submitted application in PDF format by clicking the 'View/Print' button.",
    "m.empty.personalId.or.basicInfo":
      "Information is required for the 'Identifier' field or for the applicant’s basic information (name, country of birth, and date of birth)",
    "m.empty.foreignerIdentifierKind": "Missing required information for the 'Type of foreign identifier' field",
    "m.document.signed": "The document was successfully signed.",
    "m.required.payment":
      "Please note that payment must be made in order for a review to begin. This requirement only applies to services for which there are obligations.",
    "m.required.payment.se":
      "The submitted application will be reviewed after the service fee is paid and the originals of the documents are received, in case they cannot be verified in an electronic register.",
    "m.document.not.sign": "The document is not signed signed.",
    "m.empty.personalNacidId": "Missing required information for the 'Identifier generated by NACID' field",
    "m.empty.personalId.and.foreignerCountry":
      "Missing required information for the 'Identifier' and/or 'Country that issued the foreign identifier' field",
    "m.instructions.before.reload":
      "In this section, previously submitted applications to NACID for the recognition of secondary education for the same person are displayed. The match is searched for by identifier or by matching names, date of birth, and country of birth. Please press the button to update this information according to the content of the <strong>Applicant</strong> section above. <strong>The review of previously submitted applications is for informational purposes only, but please note that if recognition has been refused for a given person based on a previous application, a new application cannot be submitted based on the same documents and circumstances.</strong>",
    "m.validation.errors.present": "Please, correct the details you have entered",
    "m.save.data.success": "Data has been successfully saved",
    "m.reload.data.success": "Data has been successfully reloaded",
    "m.save.data.fail.validation": "Please, correct the details you have entered",
    "m.loading": "Loading...",
    "m.correct.errors.to.submit": "Correct the errors to file the application",
    "m.form.edited.save.first":
      "Please, save the changes you have made by closing this window and clicking Save button OR choose to reject your changes by clicking button Reject changes.",
    "m.filing.application.success": "Your application was successfully filed under number {{entryNumber}}.",
    "m.filing.application.multiple.success":
      "Your application has been split into multiple sub-applications which were filed and received the following numbers: {{entryNumber}}.",
    "m.filing.application.fail.rules":
      "You haven't entered all the necessary details. Please correct your application to file",
    "m.regprof.experience.experienceDocument.workPeriods.none": "No work periods exist for this document",
    "m.fix.working.periods": "You need to fill in all mandatory fields for each working period",
    "m.appCheckup.instructions":
      "Here you can familiarize yourself with the content of the file on your application for the provision of a service. To find a file, you must have the file number and access code. The file number and the access code were sent to you with the message confirming the receipt of the application for the provision of the relevant service.",
    "m.view.no.longer.valid":
      "This page is no longer valid. Please search for the application again to load its details.",
    "m.appCheckup.notFound.or.notAllowed":
      "Application was not found by the details entered in the form or checkup is not allowed for application's status",
    "m.previousUniversityDiploma.info":
      'Fill this section only in casee of regulated education (for example for speciality "Law")',
    "m.finalize.application.success":
      "You have finalized your application successfully. Now you can sign it with electronic signature.",
    "m.finalize.application.multiple.success":
      "Your application has been split into multiple sub-applications and each has been finalized. Now you have to sign electronically each of the sub-applications and then file them for processing in NACID.",
    "m.esign.instructions.step1":
      "1. Download your application receipt by clicking button Download my receipt and save the file to your computer.",
    "m.esign.instructions.step2": "2. Sign the receipt file with qualified electronic signature.",
    "m.esign.instructions.step3":
      "3. Attach the electronically signed file by clicking the button to select a file and select the proper file from your local computer.",
    "m.naturalPerson.names.explanation":
      "Rules for person names: for natural persons it is mandatory to enter name; field Last name is mandatory if the person has Bulgarian national id or has Bulgarian citizenship; field  Middle name is mandatory only for persons born in Bulgaria who have Bulgarian citizenship.",
    "m.attachment.add.info":
      "Select document type or in case you can not find the proper type - enter information in the description field",
    "m.inquiry.files.info":
      "Please attach full and valid bibliographic list of the publications, for which you wish the inquiry to be done. Attached files must be editable text files in format doc, docx, rtf, odt or compatible with those",
    "m.biblioReference.files.info":
      "Attached files must be editable text files in format doc, docx, rtf, odt or compatible with those. When attaching a file, enter short description of what the file is about.",
    "m.general.files.info": "Attached files must be in PDF or JPEG format.",
    "m.regprof.files.info":
      "Attached files must be in PDF format. Each document should be scanned clearly and in color, front and back (where applicable) and all document pages must be gathered to form a single .pdf file. Separate document pages, attached as separate files, will not be examined. If the requirements are not met, the application will be returned to the user for corrections.",
    "m.rudi.files.info":
      "Attached files must be in PDF format. Each document should be scanned clearly and in color, front and back (where applicable) and all document pages must be gathered to form a single .pdf file. Separate document pages, attached as separate files, will not be examined. If the requirements are not met, the application will be returned to the user for corrections.",
    "m.seServices.applications.info":
      "If the documents are not official electronic documents or the validity and authenticity of the electronic documents cannot be verified electronically ex officio, the originals shall be submitted on site at NACID. Submission shall be in person, or through an authorized representative, or by post mail with return receipt requested.",
    "m.fees.require.approval":
      "Application fees will be determined in the process of examination of the application. You will be able to pay them once an expert from NACID confirms their amounts.",
    "m.fees.none.apply": "No application fees apply for this service",
    "m.documentDelivery.bibliographicDetails.info":
      "Please attach one or more files containing list of bibliographic descriptions of the papers you want to search for. The attached files must be in editable format - doc, docx, rtf, odt or compatible.",
    "m.university.universityContact.info":
      "Please enter full and concrete details of the person that we can contact for the purposes of the recognition. This could speed up the procedure.",
    "m.inquiry.period.info":
      "The entered period concerns all selected reports. If you wish to have different periods for the different reports - please, file separate applications.",
    "m.docDegrees.education.fields.info": "Next set of fields are applicable only for science degree Doctor!",
    "m.speciality.multiple.info":
      'You can add more than one speciality by clicking the button " + " for every speciality',
    "m.fees.service.fail":
      "Inability to calculate fees for this application. Please, make sure you have entered information in all mandatory fields.",
    "m.confirm.file.unsigned":
      "With this action you will file the application for examination in NACID and the application will be marked as filed without e-signature. Are you sure you want to continue?",
    "m.delete.app.success": "Successful application deletion",
    "m.delete.app.error": "There has been an error when deleting the application",
    "m.delete.app.confirm":
      "After you delete an application, you wont be able to restore it. Are you sure you want to delete this application?",
    "m.correspondence.is.unread.info":
      "This correspondence is not read yet. If you choose to read it, certain deadlines may start to run. To read the correspondence, click the button bellow.",
    "m.partial.data.dialog.info": "The form is not completely filled out. Do you want to save and complete it later?",
    "m.additional.info.section":
      "Additional information from the applicant regarding the attached documents and references for verification.",
    "m.diploma.url.info":
      "Enter access data for electronic registers of issued educational documents or issued Apostille certificates, where the documents can be officially verified for authenticity, accuracy, and legitimacy through their visualization. If the documents are not official electronic documents or if the validity and authenticity of the electronic documents cannot be officially verified in the described manner, the originals must be presented on site.",

    "l.step.additionalDoc.details": "Data about the related application",
    "t.additionalDoc.details": "Data about the related application",
    "l.additionalDoc.entryNumber": "Entry number",
    "l.additionalDoc.entryNumber.with.format": "Entry number (format 25-00-nnn/dd.mm.yyyy)",
    "l.additionalDoc.additionalInfo": "Additional information",
    "l.service.REC": "Certificate of Secondary Education",
    "l.service.SEON": "Official note attached to a certificate",
    "l.service.SECR": "Certificate of completed education",
    "l.official.note.previous.certificate.info.text":
      "Please enter the incoming number issued by NACID when applying for a certificate of recognition of secondary education obtained in a school of a foreign country. An application for a certificate may be submitted in connection with a certificate of recognition issued by NACID or requested for issuance from NACID.",
    "l.prevCertNumber": "Incoming number and date of the previous application (in the format 25-00-nnn/dd.mm.yyyy)",
    "l.note": "Note",
    "l.btn.calculate.experience": "Calculate professional experience",
    "l.btn.newRequest": "New request",
    "l.btn.myApplications": "My applications",
    "l.btn.pay.online": "Pay online",
    "l.btn.print": "Preview/print",
    "l.btn.saveData": "Save data",
    "l.btn.add": "Add",
    "l.btn.remove": "Remove",
    "l.btn.save": "Add",
    "l.btn.add.attachments": "Add attachment",
    "l.btn.file": "File without e-signature",
    "l.btn.file.signed": "File e-signed application",
    "l.btn.file.unsigned": "File application without e-signature",
    "l.btn.finalize.sign": "Sign and submit",
    "l.btn.previous": "Previous",
    "l.btn.next": "Next",
    "l.btn.bibliographicDetails.add": "Add bibliographic details",
    "l.btn.download.receipt.to.sign": "Download my receipt",
    "l.btn.reject.changes": "Reject changes",
    "l.btn.close": "Close",
    "l.btn.speciality.add": "Add speciality",
    "l.btn.read.correspondence": "Read this correspondence",
    "l.btn.continue": "Continue",
    "l.btn.decline": "Decline",
    "l.recognitionPurposeOtherDetails": "Add information for option other",
    "l.certificate.sec.education":
      "Certificate of recognition of secondary education acquired in a school of a foreign country, for the purpose of continuing education in higher education institutions, applying for a driving license and for access to the labor market",
    "m.help.text.certificate.sec.education":
      "* It contains only grades for subjects that are listed in the diploma itself.",
    "l.official.note":
      "Official note for the equivalence of grades in subjects studied in school education, but not reflected in the secondary education document acquired in a school in a foreign country",
    "m.help.text.official.note":
      "* The official note is requested for subjects that are not reflected in the diploma, but appear in a separate document.",
    "l.verification.letter":
      "Verification letter of recognition of secondary education acquired in a school in a foreign country, for the purpose of applying for a driving license and access to the labor market",
    "m.help.text.verification.letter": "* The verification letter does not contain grades in subjects studied.",

    "l.additionalStudiedSubjects.note": "Documents with grades for the subjects and grades in which they were studied",
    "l.additionalInfo": "Additional information",

    "l.diploma.names.se.info.text": "A document for a name change must be submitted (in the 'Attachments' section).",

    "l.diploma.register.url": "Link to Diploma Verification Register",
    "l.diploma.apostille.url": "Link to the register for checking the apostille of the diploma",
    "l.diploma.date": "Date",
    "l.additional.subject.class.year": "Class/Year in order",

    "t.previous.submitted.apps": "Previously submitted applications for the same person",
    "t.grading.scale.details": "Grades of the selected grading scale",
    "h.gradingScaleDescription": "Description of selected scale",
    "h.gradingScaleGrades": "Selected scale grades",
    "h.gradingScaleGradesEquivalent": "Bulgarian equivalent",
    "h.gradingScaleGradesEquivalentText": "Bulgarian equivalent(text)",
    "m.diplomaGrade.data.info":
      "You must enter all subjects and grades from the diploma, as well as the overall grade point average, grades from final (maturity) exams, and any other grades available in the diploma.",
    "m.grading.scale.data.info":
      "The 'Grading System' list will be populated after you enter current data for 'Country' and 'Graduation Year'",
    "m.noGradingScale.data.info":
      "Enter the Diploma Number and Year of Issue of the Diploma, along with the Date of Issue, if any.",
    "m.professional.qualification.info":
      "Professional qualification acquired through secondary education, if such has been obtained.",
    "m.service.selection.info":
      "Please indicate the documents you wish to be issued on the basis of the diploma for secondary education and professional qualification obtained abroad, for the purpose of issuing a Certificate of Completed Secondary Education.\n" +
      "Each of the services may be requested individually. However,if you request an official note listing subjects that are not reflected in the diploma on its own, you must indicate the previously requested certificate to which it will be attached.\n" +
      "For each selected document, you will receive a separate reference number, a separate receipt for the submitted application, and a separate fee will be charged in accordance with the applicable Tariff.",

    "secondaryEducation.selected.type.CERTIFICATE.short": "Certificate of Secondary Education",
    "secondaryEducation.selected.type.VERIFICATION_LETTER.short": "Verification Letter for Driving License",
    "secondaryEducation.selected.type.OFFICIAL_NOTE.short": "Official Note for Secondary Education",
    "t.page.secondaryEduRecognition.view":
      "View of a Certificate of Recognition of secondary education acquired in a school in a foreign country, for the purpose of continuing education in higher education institutions, applying for a driving license and for access to the labor market",
    "t.page.secondaryEduVerificationLetter.view":
      "View of Verification Letter for Recognition of Secondary Education Acquired in a School in a Foreign Country, for the Purpose of Applying for a Driving License and Access to the Labor Market",
    "t.page.secondaryEduOfficialNote.view":
      "View of a Official Note on the Equivalence of Grades in Subjects Studied in School Education, but Not Reflected in the Secondary Education Document Acquired in a School in a Foreign Country",

    "m.previous.submitted.action":
      "The list is empty. You can reload the data by clicking the button in the 'Previously submitted requests for the same person' section",
    "l.download.template": "Download template",
    "l.step.docEducation": "Education/Dissertation",
    "l.step.filing": "Filing",
    "l.step.diplomaEducation": "Service, diplomas",
    "l.days": "days",
    "l.months": "months",
    "l.years": "years",
    "l.serviceKind": "Service kind",
    "l.person.diplomaNames.different": "Names by personal ID document and diploma do not match",
    "l.person.qualificationNames.different": "Names by personal ID document and qualification document do not match",
    "l.copy.from.contact.address": "Copy the contact address",
    "l.declaration": "Declaration",
    "l.applicant.has.representative": "I am a representative of the applicant",
    "l.applicant.type": "Applicant is:",
    "l.applicant.type.NATURAL_PERSON": "Natural person",
    "l.applicant.type.COMPANY": "Company",
    "l.applicant.type.UNIVERSITY": "University",
    "l.btn.reload": "Reload",
    "l.btn.university.add": "Add joint education degree",
    "l.btn.educationPlace.add": "Add education place",
    "l.btn.studiedSubject.add": "Add subject",
    "l.startOfEducation": "Education start",
    "l.endOfEducation": "Education end",
    "l.educationDurationType": "Type",
    "l.educationFormOtherDetails": "Provide other option details",
    "l.docGraduationWay": "Way of receiving the degree",
    "l.graduationWayOtherDetails": "Provide other option details",
    "l.recognitionAimOtherDetails": "Provide details for other option",
    "l.attachment.attachmentType": "Attachment type",
    "l.attachment.attachmentForm": "Attachment form",
    "l.attachment.description": "Description",
    "l.application.subtype.HE_RECOGNITION": "Higher education recognition",
    "l.application.subtype.SE_RECOGNITION": "Secondary education recognition",
    "l.application.subtype.DOC_DEGREES": "Doctorate degree recognition",
    "l.application.subtype.UNI_CHECKS": "Statute/authenticity/recommendation",
    "l.application.subtype.REGULATED_PROFESSIONS": "Certificate for professional qualification",
    "l.application.subtype.OFFICIAL_NOTE": "Official note",
    "l.application.subtype.INQUIRY": "Inquiry report for citings/impact factor",
    "l.application.subtype.BIBLIO_REFERENCE": "Bibliographic reference",
    "l.application.subtype.DOCUMENT_SERVICE": "Document delivery",
    "l.application.subtype.SIGNAL": "Signal",
    "l.application.subtype.SUGGESTION": "Suggestion",
    "l.application.subtype.PUBLIC_ACCESS": "Public access",
    "l.application.subtype.RUDI_ADDITIONAL_DOCUMENTS": "Additional documents for the Academic Recognition module",
    "l.application.subtype.REGPROF_ADDITIONAL_DOCUMENTS":
      "Additional documents for the Professional Qualifications module",
    "l.application.subtype.LIBSERV_ADDITIONAL_DOCUMENTS":
      "Additional documents for the Library and Information Services module",
    "l.application.subtype.SECONDARY_ADDITIONAL_DOCUMENTS": "Additional documents for the Secondary Education module",
    "t.seRecognition.CERTIFICATE": "Secondary education certificate",
    "t.seRecognition.OFFICIAL_NOTE": "Official note",
    "t.seRecognition.VERIFICATION_LETTER": "Motor vehicle certificate",
    "l.filter.dateCreatedFrom": "Creation date from",
    "l.filter.dateCreatedTo": "Creation date to",
    "l.filter.status": "Status",
    "l.filter.applicationSubtype": "Application type",
    "l.filter.entryDateFrom": "Entry date from",
    "l.filter.entryDateTo": "Entry date to",
    "l.filter.entryNumber": "Entry number",
    "l.filter.statute": "Statute",
    "l.filter.authenticity": "Authenticity",
    "l.filter.recommendation": "Recommendation",
    "l.filter.registrationDateFrom": "Registration date from",
    "l.filter.registrationDateTo": "Registration date to",
    "l.filter.registrationNumber": "Registration number",
    "l.filter.dateReadFrom": "Read date from",
    "l.filter.dateReadTo": "Read date to",
    "l.filter.read": "Read?",
    "l.filter.seRecognitionKind": "Recognition kind",
    "l.appCheckup.accessCode": "Access code",
    "l.appCheckup.dossierNumber": "Dossier number",
    "l.regprof.education.country": "Applies for country",
    "l.regprof.education": "Select to add education details",
    "l.regprof.education.kind": "Education kind",
    "l.regprof.experience": "Select to add experience details",
    "l.regprof.experience.experienceDocument.workPeriods.fromDate": "From",
    "l.regprof.experience.experienceDocument.workPeriods.toDate": "To",
    "l.regprof.experience.experienceDocument.workPeriods.workDayHours": "Work day",
    "l.btn.workPeriod.add": "Add new work period",
    "l.btn.experienceDocument.add": "Add new document",
    "l.biblioReference.searchFrom": "Retrospection period start",
    "l.biblioReference.searchTo": "Retrospection period end",
    "l.biblioReference.nacidSearchKind": "Receive the result as",
    "l.biblioReference.foreignSearchKind": "Receive the result as",
    "l.declaration.agreeDataUsage.input":
      "I agree to use personal data for verification purposes (Please download the declaration, sign it and attach it in PDF format in the Attachments section)",
    "l.declaration.agreeDataUsage.uniChecks.input":
      "The owner of the qualification agrees for NACID to use their personal data for verification purposes (Please download the declaration, sign it and attach it in PDF format in the Attachments section)",
    "l.declaration.agreeDataUsage.se.input":
      "I agree for my personal data to be used for the purposes of the verification",
    "l.declaration.documentsDeclaration.representative":
      "In my capacity as an authorized representative, I hereby declare that the application for the recognition of secondary education obtained at a foreign school, along with the accompanying documents, has been provided to me by the applicant. I am aware of the criminal liability I bear under Article 313 of the Criminal Code for declaring false information.",
    "l.regprof.education.nonRevokedRightToPractice.input":
      "The rights to practice the profession are not revoked (Please download the declaration, write it and attach it in PDF format in the Attachments section)",
    "l.inquiry.periodFrom": "Time frame from",
    "l.inquiry.periodTo": "Time frame to",
    "l.fee.totalFees": "Total fees",
    "l.fee.BGN": "lv.",
    "l.fee.EUR": "eur.",
    "l.rudiSpecialityOriginalName.uniChecks": "Speciality/professional referral - original name",
    "l.rudiSpecialityName.uniChecks": "Speciality/professional referral - translation",
    "l.reverted.app": "Reverted application",
    "l.read": "read",
    "l.new": "new",
    "l.correspondence.dateCreated": "Creation date",
    "l.correspondence.dateRead": "Read date",
    "l.correspondence.appType": "Of kind",
    "l.correspondence.about": "About",
    "l.correspondence.registrationNumber": "Document number/date",
    "l.contactAddress.hasContactAddress": "I would like to enter contact address",
    "l.schoolContact": "Secondary school contact person",
    "l.name.and.town": "Name, city",
    "l.schoolName.and.town": "School name, city",
    "l.agreeMailCorrespondence": "I agree to receive information and notifications at the specified email address.",

    "h.entryNumber": "Entry number",
    "h.entryDate": "Entry date",
    "h.serviceType": "Service type",
    "h.status": "Status",
    "h.options": "Options",
    "h.application.dateCreated": "Creation date",
    "h.application.lastSubmissionDate": "Submission date",
    "h.application.applicantName": "Applicant",
    "h.application.entryNumberAndDate": "Application Num/Date",
    "h.application.applicationSubtype": "Type",
    "h.application.lastStatusName": "Status",
    "h.application.signed": "E-signed",
    "h.application.paid": "Paid",
    "h.application.original.documents": "Original documents",
    "h.fee.name": "Fee",
    "h.fee.amount": "Amount",
    "h.docBibliographicEntry.sources": "Search in/deliver from",
    "h.docBibliographicEntry.deliveryResultKind": "Document delivery kind",
    "h.docBibliographicEntry.file": "Attached file",
    "h.docBibliographicEntry.options": "Options",
    "h.correspondence.dateCreated": "Creation date",
    "h.correspondence.about": "About",
    "h.correspondence.registrationNumber": "Document number/date",
    "h.correspondence.dateRead": "Read date",
    "h.certificate.files": "Files",
    "h.certificate.registrationNumber": "Document number/date",

    "validation.field.required": "This field is mandatory",
    "validation.field.email.bad.format": "Invalid email address",
    "validation.field.invalid": "Invalid value",
    "validation.attachment.file.required": "You must select a file",
    "validation.file.size": "The size of the file exceeds the allowed maximum",
    "validation.file.type": "The type of the file is not allowed",
    "validation.file.type.mismatch": "The type of the file does not match the extension",
    "validation.field.empty.value.in.array": "You have added an empty value. Please remove it",
    "validation.field.bad.value.in.array": "You have an invalid value in the list. Please correct the error",
    "validation.field.select": "You have to select at least one option",
    "validation.attachment.file.invalid": "Necessary information is missing for the added file",
    "validation.previousInquiryNum.or.CITINGS":
      "Fill in entry number of previous application for citations report (in the format 94-05-<number>/dd.mm.yyyy) or select as application 'publications citations'",
    "validation.add.bibliographic.details": "Add at least one bibliographic details entry",
    "validation.previousInquiryNum.errorOrBad": "Invalid number or not possible to verify number",
    "validation.previousInquiryNum.invalid": "Invalid value. Valid format: 94-05-<number>/dd.mm.yyyy",
    "validation.start.year.bigger": "Start year can not be bigger than end year",
    "validation.end.year.bigger.than.diploma.year": "End year can not be bigger than diploma date year",
    "validation.start.year.bigger.than.diploma.year": "Start year can not be bigger than diploma date year",
    "validation.result.receive.electronic.error":
      "Because you have selected to receive the certificate in paper, you can not select to receive the individual administrative act electronically or through the secure system for e-delivery",
    "validation.university.name.invalid":
      "Incorrect format of the text. You need to enter university name, followed by city and country - all parts separated by commas.",
    "validation.from.before.to": "The 'To' date must be the same as or later than the 'From' date.",
    "validation.field.required.manual.check.warning":
      "You have missing required fields (in red). Please fill them first before submitting.",
    "diplomaHolder.personalId.validation.field.invalid":
      "Diploma Holder: Invalid identifier. You need to review whether you have selected the correct identifier type and the identifier itself.",

    "rule.applicantDetails.agreeDataUsage": "I agree to use personal data for verification purposes",
    "rule.applicantDetails.documentsDeclaration":
      "I declare that the documents and data specified in the application for recognition of higher education acquired in a foreign higher school are true and authentic",
    "rule.applicantDetails.documentsDeclaration.representative":
      "In my capacity as an authorized representative, I declare that the documents and the information related to them have been provided to me by the applicant",
    "rule.applicantDetails.resultReceive": "Way of receiving of notifications",
    "rule.educationDetails.prevCertNumber":
      "Incoming number and date of the previous application (in the format 25-00-nnn/dd.mm.yyyy)",
    "rule.educationDetails.universitiesData.name": "University name",
    "rule.educationDetails.educationPlaces.country.city": "Country and city of the secondary school",
    "rule.educationDetails.specialities": "Speciality",
    "rule.educationDetails.startOfEducation": "Start of education",
    "rule.educationDetails.endOfEducation": "End of education",
    "rule.educationDetails.gainedLevel": "Gained degree",
    "rule.documentDetails.attachments.declarationPersonalDetails":
      "Attached document: Declaration for personal details",
    "rule.documentDetails.attachments.universityDiplomaOriginal":
      "Attached document: University diploma - Form: original",
    "rule.documentDetails.attachments.universityDiplomaTranslation":
      "Attached document: University diploma - Form: translation",
    "rule.documentDetails.attachments.diplomaAttachmentOriginal":
      "Attached document: Diploma attachment - Form: original",
    "rule.documentDetails.attachments.diplomaAttachmentTranslation":
      "Attached document: Diploma attachment - Form: translation",
    "rule.educationDetails.schoolname": "School name",
    "rule.educationDetails.diplomaNumber": "Diploma-number",
    "rule.educationDetails.gradingScale": "Grading scale",
    "rule.educationDetails.studiedSubjects": "Subjects studied from the diploma",
    "rule.educationDetails.diplomaYear": "Year of graduation",
    "rule.educationDetails.gainedLevelProfGroup": "Professional group",
    "rule.documentDetails.attachments.otherProofs": "Attached document: Other proofs (instead of dissertation)",
    "rule.documentDetails.attachments.scienceDegreeDiplomaOriginal":
      "Attached document: Diploma for science degree - Form:original",
    "rule.documentDetails.attachments.scienceDegreeDiplomaTranslation":
      "Attached document: Diploma for science degree - Form::translation",
    "rule.educationDetails.graduationWay": "Way of receiving the degree",
    "rule.applicantDetails.dateOfBirth": "Date of birth",
    "rule.applicantDetails.birthCountry": "Country of birth",
    "rule.applicantDetails.city": "Place of birth",
    "rule.educationDetails.country": "Applies for country",
    "rule.educationDetails.educationOrExperience": "Education or experience",
    "rule.educationDetails.professionalQualificationRequested":
      "Professional qualification for which certificate is requested",
    "rule.documentDetails.attachments.declarationRightsPracticeProfession":
      "Attached document: Declaration for the right to practice the profession",
    "rule.educationDetails.education.kind": "Education kind",
    "rule.educationDetails.education.educationInstitutionName": "Old or new education institution name",
    "rule.educationDetails.education.professionalQualification": "Professional qualification by documents",
    "rule.educationDetails.education.specialities": "Speciality by documents",
    "rule.educationDetails.education.documentKind": "Document kind",
    "rule.educationDetails.experience.profession": "Profession",
    "rule.educationDetails.experience.experienceDocuments.type": "Experience document type",
    "rule.educationDetails.experience.experienceDocuments.institutionName": "Issuing institution",
    "rule.educationDetails.experience.experienceDocuments.workPeriod":
      "Work period (added for every experience document)",
    "rule.educationDetails.sarSelected": "Service kind",
    "rule.educationDetails.diplomaHolder": "Diploma owner",
    "rule.educationDetails.serviceType": "Service type",
    "rule.officialNoteDetails.kindsSelected": "Official notes kinds selected",
    "rule.inquiry.kindsSelected": "Selected inquiry kinds",
    "rule.bibliographicReference.searchSelected": "Selected search kind",
    "rule.bibliographicReference.theme": "Theme entered",
    "rule.bibliographicReference.languagesSelected": "Selected languages of publications/sources",
    "rule.docDelivery.hasBibliographicDetails": "Filled in bibliographic details",
    "rule.suggestion.hasSuggestion": "Suggestion details",
    "rule.signal.hasViolationDescription": "Violation details filled in",
    "rule.signal.hasViolationPlace": "Information filled in for the violation place",
    "rule.documentDetails.attachments.rightToPracticeProfessionDeclaration":
      "Attached document: Declaration for right to practice the profession",
    "rule.documentDetails.attachments.authorsPublicationsList": "Attached document: List of author's publications",
    "rule.documentDetails.attachments.diplomaAttachment": "Attached document: Diploma attachment",
    "rule.documentDetails.attachments.universityDiploma": "Attached document: Diploma for higher education",
    "rule.documentDetails.attachments.dissertation": "Attached document: Dissertation",
    "rule.documentDetails.attachments.originalApplicantApplication":
      "Attached document: Application form the applicant",
    "rule.educationDetails.recognitionAim": "Selected recognition purpose",
    "rule.educationDetails.recognitionAim.officialNote":
      "Allowed options for recognition purpose, when an official note is selected - 'Continuing education' and 'Other'",
    "rule.educationDetails.recognitionAim.verificationLetter":
      "Allowed options for recognition purpose, when a verification letter is selected - 'Application for obtaining a driving license', 'Access to the labor market' and 'Other'",
    "rule.educationDetails.originalGainedLevel": "Original education degree",
    "rule.educationDetails.originalGainedLevelTranslated": "Original education degree - translation",
    "rule.educationDetails.educationForm": "Education form",
    "rule.educationDetails.recognitionCategory": "Recognition kind (education/degree)",
    "rule.publicAccess.hasAbout": "Public information access about",
    "rule.applicantDetails.certificateResultForm": "Certificate receive in form",
    "t.officialNote.application.details": "Application details",
    "rule.officialNoteDetails.serviceType": "Service type",
    "rule.se.educationDetails": "Education details",
    "rule.bibliographicReference.hasSearchKind": "Receive the search result as",
    "rule.bibliographicReference.keywordsEntered": "Keywords and requirements in relation to the theme",
    "rule.bibliographicReference.hasPeriodFrom": "Retrospection period start",
    "rule.bibliographicReference.hasPeriodTo": "Retrospection period end",
    "rule.inquiry.hasPeriodFrom": "Time frame from",
    "rule.inquiry.hasPeriodTo": "Time frame to",
    "rule.inquiry.validPreviousInquiry": "Valid previous inquiry number",
    "rule.educationDetails.validPrevCertNumber": "Valid number of a previously submitted certificate application",
    "rule.applicantDetails.agreeMailCorrespondence":
      "I agree to receive information and notifications at the specified email address",
    "rule.entryNumber": "Entry number",
    "rule.additionalDoc.validEntryNumber": "Valid case number",
    "rule.additionalDoc.validFormatEntryNumber": "Valid format for case number",
    "m.validation.warnings.gradeNotInScale": "The entered grade is not part of the selected grading scale",
    "validation.charCount.invalid.250": "Invalid value. Maximum length - 250",
    "rule.documentDetails.attachments.se.diploma":
      "Attached document: Diploma – original and translation (with the required certifications)",
    "rule.documentDetails.attachments.se.documentContinueHigherEducation":
      "Attached document: Document stating that the diploma grants the right to continue education at higher education institutions – original and translation (with the required certifications)",
    "rule.documentDetails.attachments.se.documentSubjectGradeClasses":
      "Attached document: Documents with subjects, grades and classes – original and translation (with the required certifications)",
    "rule.documentDetails.attachments.se.differentDiplomaNames":
      "Attached document: Document certifying the change in the applicant's name",
    "rule.documentDetails.attachments.se.hasRepresentative": "Attached document: Letter of attorney",
    "t.resultReceive.way.paper": "Way of receiving of the issued individual administrative act in paper",
    "t.resultReceive.way.electronic": "Way of receiving of the issued individual administrative act electronically",
    "t.validation.field.language.invalid": "Invalid value. Only Bulgarian language characters are allowed.",
    "validation.charCount.invalid.120": "Invalid value. Maximum length - 120",
  },
});

export default messagesEn;
